import React from "react";
import { connect } from "react-redux";
import gql from "graphql-tag";
import { getInspection } from "../graphql/queries";
import { updateInspection, updateVehicle } from "../graphql/mutations";
import { API, graphqlOperation, Storage } from "aws-amplify";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  Label,
  Button,
  Card as Cd,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

import CardHeader from "../components/Card/CardHeader.jsx";
import CardBody from "../components/Card/CardBody.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import { ToastContainer, toast } from "react-toastify";
import InspectionCheckData from "../data/InspectionCheckData";
import { styles } from "../assets/css/styles";
import InspectinDefectsData from "../data/defects";
import { spinnerService } from "@chevtek/react-spinners";
var schema = require("../graphql/schema.json");

let today = new Date();
let month =
  today.getMonth() + 1 < 10 ? `0${today.getMonth() + 1}` : today.getMonth() + 1;
let date = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
let currentDate = `${today.getFullYear()}-${month}-${date}`;
class EditInspection extends React.Component {
  state = {
    success: false,
    nextInspectionDue: "",
    open: false,
    defectState: "read",
    type: "defects",
    redTag: false,
    defectDesc: "",
    defectType: "",
    files: [],
    uploadedFiles: []
  };
  handleClose = () => {
    if (this.state.type === "defects" && this.state.defectState === "add")
      this.addDefect();
    else if (this.state.type === "defects" && this.state.defectState === "edit")
      this.editDefect();
    else if (this.state.type === "observation") this.eidtObservations();
    else this.setState({ open: false });
  };
  addDefect = () => {
    let { defectDesc, defectType, redTag, inspectionDefects } = this.state;
    if (defectType === "") document.getElementById("defectType").focus();
    else if (defectDesc === "") document.getElementById("defectDesc").focus();
    else {
      inspectionDefects.push({
        defectType,
        defectDesc,
        redTag
      });

      this.saveDefect(inspectionDefects);
    }
  };
  editDefect = () => {
    let {
      index,
      inspectionDefects,
      defectType,
      defectDesc,
      redTag
    } = this.state;
    inspectionDefects[index].defectType = defectType;
    inspectionDefects[index].defectDesc = defectDesc;
    inspectionDefects[index].redTag = redTag;
    this.saveDefect(inspectionDefects);
  };
  deleteDefect = index => {
    let { inspectionDefects } = this.state;
    inspectionDefects =
      inspectionDefects.length > 1 ? inspectionDefects.splice(index, 1) : [];
    this.saveDefect(inspectionDefects);
  };
  saveDefect = inspectionDefects => {
    let { id } = this.props.match.params;
    if (inspectionDefects.length > 0)
      inspectionDefects = inspectionDefects.map(element => {
        delete element.__typename;
        return element;
      });
    let input = { id, inspectionDefects };
    API.graphql(graphqlOperation(updateInspection, { input }))
      .then(res => {
        this.setState({
          defectDesc: "",
          defectType: "",
          redTag: false,
          defectState: "read"
        });
        this.componentDidMount();
      })
      .catch(err => {});
  };
  eidtObservations = () => {
    let { inspectionObservations } = this.state;
    let { id } = this.props.match.params;

    let input = { id, inspectionObservations };
    API.graphql(graphqlOperation(updateInspection, { input }))
      .then(res => {
        this.setState({ open: false });
      })
      .catch(err => {});
  };
  changeHandler = e => {
    this.setState({ [e.target.id]: e.target.value });
  };
  redTagHandler = () => {
    this.setState({ redTag: !this.state.redTag });
  };
  submitHandler = async () => {
    let { id } = this.props.match.params;
    await this.uploadImages();
    let {
      nextInspectionDue,
      inspectionStatus,
      inspectionUploads,
      inspectionType,
      calBitId,
      customerVehicleId,
      uploadedFiles
    } = this.state;
    inspectionUploads = inspectionUploads.concat(uploadedFiles);
    if (inspectionUploads.length > 0)
      inspectionUploads = inspectionUploads.map(element => {
        delete element.__typename;
        return element;
      });
    var input = {
      id,
      nextInspectionDue,
      inspectionUploads,
      inspectionStatus,
      inspectionType
    };

    try {
      await API.graphql(graphqlOperation(updateInspection, { input }));
      input = { id: calBitId, customerVehicleId: customerVehicleId };
      API.graphql(graphqlOperation(updateVehicle, { input }))
        .then(() => {
          spinnerService.hide();
        })
        .catch(err => {});
      toast.success("Inspection Edited");
      this.props.history.push("/inspection");
    } catch (err) {
      spinnerService.hide();
    }
  };
  componentDidMount() {
    let { id } = this.props.match.params;
    let { client } = this.props;
    spinnerService.show("mySpinner");
    client
      .query({
        query: gql(getInspection),
        fetchPolicy: `network-only`,
        variables: { id }
      })
      .then(data => {
        let schemaData = schema.data.__schema.types.filter(item => {
          return item.kind === "ENUM" && item.name === "INSPECTIONTYPE";
        });
        let inspection_Types = schemaData[0].enumValues;
        let status = schema.data.__schema.types.filter(item => {
          return item.kind === "ENUM" && item.name === "INSPECTIONSTATUS";
        });
        let inspection_Status = status[0].enumValues;
        let {
          nextInspectionDue,
          inspectionObservations,
          startAt,
          vehicle,
          inspectionType,
          inspectionStatus,
          inspectionDefects,
          inspectionUploads
        } = data.data.getInspection;
        let { customerVehicleId } = vehicle;
        let calBitId = vehicle.id;
        let inspector = data.data.getInspection.inspector;
        inspectionDefects = inspectionDefects === null ? [] : inspectionDefects;
        inspectionUploads = inspectionUploads === null ? [] : inspectionUploads;
        this.setState({
          success: true,
          inspection_Status,
          inspection_Types,
          inspectionUploads,
          inspectionDefects,
          inspectionObservations,
          nextInspectionDue,
          calBitId,
          inspector,
          customerVehicleId,
          startAt,
          inspectionType,
          inspectionStatus
        });
        spinnerService.hide("mySpinner");
      })
      .catch(err => {
        spinnerService.hide("mySpinner");
      });
  }
  observationSelect = obj => {
    let { inspectionObservations } = this.state;
    inspectionObservations =
      inspectionObservations === null ? [] : inspectionObservations;
    if (!inspectionObservations.includes(obj)) inspectionObservations.push(obj);
    else {
      inspectionObservations.splice(inspectionObservations.indexOf(obj), 1);
    }
    this.setState({ inspectionObservations });
  };
  defectComponent = () => {
    let {
      defectState,
      defectType,
      defectDesc,
      redTag,
      inspectionDefects
    } = this.state;
    let arr = inspectionDefects.map(item => {
      return item.defectType;
    });
    let data = InspectinDefectsData.filter(item => {
      return !arr.includes(item.name) && item.name !== defectType;
    });

    if (defectState === "read") {
      if (inspectionDefects === null || inspectionDefects.length === 0) {
        return <React.Fragment>No Defects Found</React.Fragment>;
      }
      return (
        <React.Fragment>
          {inspectionDefects !== null
            ? inspectionDefects.map((obj, key) => {
                let index = inspectionDefects.indexOf(obj);
                return (
                  <div key={key}>
                    <p>Type: {" " + obj.defectType}</p>
                    <p>Desc: {" " + obj.defectDesc}</p>
                    <p>RedTag: {obj.redTag ? "true" : "false"}</p>
                    <div style={{ textAlign: "right" }}>
                      <span className="fancy-a">
                        <a
                          href="#"
                          onClick={() =>
                            this.setState({
                              redTag: obj.redTag,
                              defectState: "edit",
                              defectType: obj.defectType,
                              defectDesc: obj.defectDesc,
                              redTag: obj.redTag,
                              index
                            })
                          }
                        >
                          Edit
                        </a>
                      </span>
                      <span className="fancy-a">
                        <a href="#" onClick={() => this.deleteDefect(index)}>
                          Delete
                        </a>
                      </span>
                    </div>
                    <hr style={{ background: "black" }} />
                  </div>
                );
              })
            : "No Defects"}
        </React.Fragment>
      );
    } else if (defectState === "add" || defectState === "edit") {
      return (
        <React.Fragment>
          <select
            className="form-control"
            value={defectType}
            onChange={this.changeHandler}
            id="defectType"
          >
            <option>{defectType}</option>

            {data.map(item => {
              return <option>{item.name}</option>;
            })}
          </select>
          <div style={{ marginTop: 20 }}>
            <textarea
              className="form-control"
              id="defectDesc"
              value={defectDesc}
              onChange={this.changeHandler}
              rows={10}
            ></textarea>
          </div>
          <FormGroup check>
            <Input
              type="checkbox"
              id="redTag"
              style={{ height: 20, width: 20, cursor: "pointer" }}
              name="check"
              checked={redTag}
              onChange={this.redTagHandler}
            />
            <Label
              for={"redTag"}
              check
              style={{
                margin: 5,
                color: "black",
                fontSize: 14,
                cursor: "pointer"
              }}
            >
              RedTag
            </Label>
          </FormGroup>
        </React.Fragment>
      );
    }
  };
  fileSelect = e => {
    let file = e.target.files[0];
    let { files } = this.state;
    files.push(file);
    this.setState({ files });
  };
  removeFile = item => {
    let { files } = this.state;
    files.splice(files.indexOf(item), 1);
    this.setState({ files });
  };
  removeUploadedFile = item => {
    let { inspectionUploads } = this.state;
    inspectionUploads.splice(inspectionUploads.indexOf(item), 1);
    this.setState({ inspectionUploads });
  };
  uploadImages = async () => {
    const { files, uploadedFiles } = this.state;
    if (files.length === 0) {
      return;
    }
    await Promise.all(
      files.length !== 0 &&
        files.map(async (item, index) => {
          if (item.file === null) {
            uploadedFiles.push({
              title: item.title,
              dateAchieved: currentDate,
              attachment: null
            });
          } else {
            try {
              let key = await Storage.put(
                new Date().getTime() + item.name,
                item
              );
              uploadedFiles.push({
                bucket: "calbitwebappuploadbucket1254-dev",
                region: "us-east-2",
                key: key.key
              });
              this.setState({ uploadedFiles });
            } catch (err) {}
          }
        })
    );
  };
  render() {
    function _onFocus(e) {
      e.currentTarget.type = "date";
    }
    function _onBlur(e) {
      e.currentTarget.type = "text";
    }
    let { classes } = this.props;
    let {
      success,
      nextInspectionDue,
      inspectionObservations,
      inspection_Types,
      inspection_Status,
      calBitId,
      files,
      customerVehicleId,
      inspector,
      inspectionUploads,
      inspectionType,
      inspectionStatus,
      inspectionDefects
    } = this.state;
    if (!success) return <div></div>;
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {this.state.type === "inspector"
              ? "Inspector"
              : this.state.type === "observation"
              ? "Observation"
              : this.state.type === "defects"
              ? "Defects"
              : null}
            {" Details"}
            {this.state.type === "defects" &&
              this.state.defectState !== "add" &&
              this.state.defectState !== "edit" && (
                <span
                  className="fancy-a"
                  style={{ fontWeight: "normal", fontSize: 14, float: "right" }}
                >
                  <a
                    href="#"
                    onClick={() => this.setState({ defectState: "add" })}
                  >
                    Add Defect
                  </a>
                </span>
              )}
          </DialogTitle>
          <DialogContent style={{ minWidth: 400 }}>
            {this.state.type === "inspector" ? (
              <DialogContentText id="alert-dialog-description">
                <p>Name: {inspector.name}</p>
                <p>Address: {inspector.homeAddress}</p>
              </DialogContentText>
            ) : null}
            {this.state.type === "observation" ? (
              <DialogContentText id="alert-dialog-description">
                {InspectionCheckData !== null
                  ? InspectionCheckData.map((obj, key) => {
                      return (
                        <React.Fragment>
                          <FormGroup check>
                            <Input
                              type="checkbox"
                              checked={inspectionObservations.includes(obj.Obs)}
                              name="check"
                              id={obj.ObsID}
                              onChange={() => this.observationSelect(obj.Obs)}
                            />
                            <Label for={obj.ObsID} check>
                              {obj.Obs}
                            </Label>
                          </FormGroup>
                        </React.Fragment>
                      );
                    })
                  : "No Observations"}
              </DialogContentText>
            ) : null}
            {this.state.type === "defects" ? (
              <DialogContentText id="alert-dialog-description">
                {this.defectComponent()}
              </DialogContentText>
            ) : null}
          </DialogContent>
          <DialogActions>
            {this.state.defectState === "edit" ||
            this.state.defectState === "add" ? (
              <Button
                onClick={() =>
                  this.setState({
                    defectState: "read",
                    defectDesc: "",
                    defectType: "",
                    redTag: false
                  })
                }
                color="primary"
              >
                Back
              </Button>
            ) : null}
            {
              <Button onClick={this.handleClose} color="primary">
                {this.state.type !== "inspector"
                  ? this.state.defectState === "edit"
                    ? "Edit"
                    : this.state.defectState === "add"
                    ? "Add"
                    : this.state.defectState === "read"
                    ? "Save"
                    : null
                  : "Close"}
              </Button>
            }
          </DialogActions>
        </Dialog>
        <section className="section section-shaped section-lg">
          <Container className="pt-lg-sm pt-2">
            <ToastContainer />
            <Row className="justify-content-center">
              <Col lg="10">
                <Cd>
                  <CardHeader color="primary">
                    <h4 className={classes.cardTitleWhite}>Edit Inspection</h4>
                    <p className={classes.cardCategoryWhite}>
                      Edit Information Below
                    </p>
                  </CardHeader>
                  <CardBody>
                    <Form>
                      <div>
                        <Row>
                          <Col>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText></InputGroupText>
                                </InputGroupAddon>
                                <Input
                                  type="text"
                                  value={customerVehicleId}
                                  id="customerVehicleId"
                                  onChange={this.changeHandler}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText></InputGroupText>
                                </InputGroupAddon>
                                <Input
                                  type="text"
                                  value={calBitId}
                                  onChange={this.changeHandler}
                                  id="calBitId"
                                  disabled
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText></InputGroupText>
                                </InputGroupAddon>
                                <Input
                                  id="inspectionType"
                                  value={inspectionType}
                                  onChange={this.changeHandler}
                                  placeholder="Type Name"
                                  type="select"
                                >
                                  {inspection_Types.map(item => {
                                    return (
                                      <option style={{ color: "black" }}>
                                        {item.name}
                                      </option>
                                    );
                                  })}
                                </Input>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText></InputGroupText>
                                </InputGroupAddon>
                                <Input
                                  id="inspectionStatus"
                                  value={inspectionStatus}
                                  onChange={this.changeHandler}
                                  placeholder="Type Name"
                                  type="select"
                                >
                                  {inspection_Status.map(item => {
                                    return (
                                      <option style={{ color: "black" }}>
                                        {item.name}
                                      </option>
                                    );
                                  })}
                                </Input>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText></InputGroupText>
                                </InputGroupAddon>
                                <Input
                                  id="nextInspectionDue"
                                  onFocus={e => _onFocus(e)}
                                  onBlur={e => _onBlur(e)}
                                  type="text"
                                  value={nextInspectionDue}
                                  onChange={this.changeHandler}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          {/* <Col>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Input
                                type="text"
                                value={startAt}
                                onChange={this.changeHandler}
                                id="startAt"
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col> */}
                        </Row>
                        <Row className="justify-content-center">
                          <Col>
                            <Cd>
                              <CardHeader>
                                <h5>Inspection files</h5>
                                <div className="upload-btn-wrapper">
                                  <button
                                    className="btn"
                                    onClick={e => e.preventDefault()}
                                  >
                                    Upload a file('s)
                                  </button>
                                  <input
                                    type="file"
                                    name="myfile"
                                    onChange={this.fileSelect}
                                  />
                                </div>
                              </CardHeader>
                              <CardBody>
                                {inspectionUploads.map(item => {
                                  return (
                                    <span
                                      style={{ fontSize: 16, margin: 10 }}
                                      className="badge badge-pill badge-primary"
                                    >
                                      {item.key
                                        .replace(/[0-9]/g, "")
                                        .replace(/["'()]/g, "")}
                                      <span
                                        style={{ margin: 5, cursor: "pointer" }}
                                        onClick={() =>
                                          this.removeUploadedFile(item)
                                        }
                                      >
                                        X
                                      </span>
                                    </span>
                                  );
                                })}
                                {files.map(item => {
                                  return (
                                    <span
                                      style={{ fontSize: 16, margin: 10 }}
                                      className="badge badge-pill badge-primary"
                                    >
                                      {item.name}
                                      <span
                                        style={{ margin: 5, cursor: "pointer" }}
                                        onClick={() => this.removeFile(item)}
                                      >
                                        X
                                      </span>
                                    </span>
                                  );
                                })}
                              </CardBody>
                            </Cd>
                          </Col>
                        </Row>
                        <Row style={{ marginTop: "30px" }}>
                          <Col xs="8">
                            <span className="fancy-a">
                              <a
                                onClick={() =>
                                  this.setState({
                                    type: "inspector",
                                    open: true
                                  })
                                }
                                href="#"
                                size="sm"
                              >
                                View Inspector
                              </a>
                            </span>
                            <span className="fancy-a">
                              <a
                                onClick={() =>
                                  this.setState({ type: "defects", open: true })
                                }
                                href="#"
                                size="sm"
                              >
                                Edit Defects
                              </a>
                            </span>
                            <span className="fancy-a">
                              <a
                                onClick={() =>
                                  this.setState({
                                    type: "observation",
                                    open: true
                                  })
                                }
                                href="#"
                                size="sm"
                              >
                                Edit Observations
                              </a>
                            </span>
                          </Col>
                        </Row>
                        <Row className="justify-content-center">
                          <Col md="4">
                            <Button
                              className=" btn-lg btn-block mt-2"
                              color="default"
                              onClick={() =>
                                this.props.history.push(
                                  `/inspection/details/${this.props.match.params.id}`
                                )
                              }
                            >
                              Back
                            </Button>
                          </Col>
                          <Col md="4">
                            <Button
                              className=" btn-lg btn-block mt-2"
                              color="primary"
                              onClick={this.submitHandler}
                            >
                              Update
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </Form>
                  </CardBody>
                </Cd>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    inspections: state.listInspection.data
  };
};
export default EditInspection = connect(
  mapStateToProps,
  null
)(withStyles(styles)(EditInspection));



// WEBPACK FOOTER //
// ./src/pages/editInspection.js